import React from "react";
import { Pagination } from "@nextui-org/react";

export default function PaginationBasic({
  page,
  totalItems,
  itemsPerPage,
  onPageChange,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="flex flex-row gap-5 mt-[25%] md:mt-[5%] ">
      <Pagination
        dir="ltr"
        total={totalPages}
        page={page}
        onChange={onPageChange}
        showControls
      />
    </div>
  );
}
